// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_6f07a8b5","outerContainer":"_3f061dc5","secondaryToolbar":"_0aa698b0","doorHangerRight":"d58a7b15","toolbarContainer":"b093c89d","toolbarViewerMiddle":"_72d0a265","progressBar":"_215e25a9","back-to-application":"c8d991b9","root":"b24eb86e","header":"e85c52c3","leftSideWrapper":"_1af8c25a","avatar":"a9151c4e","title":"_0e3301c6","date":"d94b2a65","contentWrapper":"_99ef012c","memberCard":"b00d14c8","role":"_4d11b424","description":"_31ca488a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/ChatMembersModal/index.styl
// module id = 5052
// module chunks = 39